import { render, staticRenderFns } from "./left-button.vue?vue&type=template&id=4b490d3f&scoped=true&"
import script from "./left-button.vue?vue&type=script&lang=js&"
export * from "./left-button.vue?vue&type=script&lang=js&"
import style0 from "./left-button.vue?vue&type=style&index=0&id=4b490d3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b490d3f",
  null
  
)

export default component.exports